// components/atoms/SocialLink.tsx
import { useRef } from 'react';
import styles from './SocialLinkMenu.module.css';
import { useTextReveal } from '@/hooks/useRevealAnimations';
import { useCursor } from '@/contexts/CursorContext';

export const SocialLinkMenu = ({
  label,
  href,
  isOpen,
  index,
}: {
  label: string;
  href: string;
  isOpen: boolean;
  index: number;
}) => {
  const ref = useRef<HTMLAnchorElement>(null);

  const { setState } = useCursor();

  const onMouseEnter = () => {
    setState('link');
  };

  const onMouseLeave = () => {
    setState('default');
  };

  useTextReveal(ref.current, {
    enabled: isOpen,
    stagger: 0.3,
    yStart: 30,
    delay: 0.8 + index * 0.2,
  });

  return (
    <a
      ref={ref}
      href={href}
      className={`${styles.socialLink} textReveal`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>{label}</span>
    </a>
  );
};
